import { ComponentAPI } from '../../../api/bussched/ComponentAPI';

export class MarginStyleCommand {
    constructor() {
        this.componentApi = new ComponentAPI();
    }

    getAvailableTargets(componentType, successCallback, errorCallback) {
        const apiResult = this.componentApi.listMarginTargets(componentType);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter os elementos disponíveis para configuração de um fundo");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/MarginStyleCommand.js